import { render } from "./ReportFull.vue?vue&type=template&id=5c58bbf2"
import script from "./ReportFull.vue?vue&type=script&lang=js"
export * from "./ReportFull.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptweb\\release-RPTWEB-3376\\client\\databook\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__